let authInfo = localStorage.getItem('eventBuizz');
const initialState = (authInfo && authInfo !== undefined ? JSON.parse(authInfo) : {});
 
export function auth(state = initialState, action) {
    switch (action.type) {
        case "auth-info":
            if (action.user && Object.keys(action.user).length > 0) {
                localStorage.setItem('eventBuizz', JSON.stringify(action.user));
                return action.user;
            } else {
                // Handle logout - clear localStorage and return empty state
                localStorage.removeItem('eventBuizz');
                return {};
            }
        default:
            return state;
    }
}